module.exports = __webpack_public_path__ + "static/img/swiper11.d924f1a7.png";